// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.certificate-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  min-height: 80vh;
}

.certificate-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 30px;
  padding: 20px 0;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.btn-primary {
  background-color: #ff6b35;
  color: white;
}

.btn-primary:hover {
  background-color: #e55a2b;
  transform: translateY(-2px);
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #5a6268;
  transform: translateY(-2px);
}

.certificate-content {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.loading {
  text-align: center;
  padding: 60px 20px;
}

.loading h2 {
  color: #ff6b35;
  margin-bottom: 30px;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #ff6b35;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error {
  text-align: center;
  padding: 60px 20px;
  color: #dc3545;
}

.error h2 {
  margin-bottom: 20px;
}

.error p {
  margin-bottom: 10px;
  font-size: 16px;
}

/* Print styles */
@media print {
  .certificate-actions {
    display: none !important;
  }
  
  .certificate-container {
    max-width: none;
    margin: 0;
    padding: 0;
  }
  
  .certificate-content {
    box-shadow: none;
    border-radius: 0;
  }
  
  body {
    margin: 0;
    padding: 0;
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .certificate-container {
    padding: 10px;
  }
  
  .certificate-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .btn {
    width: 200px;
    margin-bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Certificate.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;AACF","sourcesContent":[".certificate-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  min-height: 80vh;\n}\n\n.certificate-actions {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n  margin-bottom: 30px;\n  padding: 20px 0;\n}\n\n.btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.btn-primary {\n  background-color: #ff6b35;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #e55a2b;\n  transform: translateY(-2px);\n}\n\n.btn-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background-color: #5a6268;\n  transform: translateY(-2px);\n}\n\n.certificate-content {\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.loading {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.loading h2 {\n  color: #ff6b35;\n  margin-bottom: 30px;\n}\n\n.spinner {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #ff6b35;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n  margin: 0 auto;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.error {\n  text-align: center;\n  padding: 60px 20px;\n  color: #dc3545;\n}\n\n.error h2 {\n  margin-bottom: 20px;\n}\n\n.error p {\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n\n/* Print styles */\n@media print {\n  .certificate-actions {\n    display: none !important;\n  }\n  \n  .certificate-container {\n    max-width: none;\n    margin: 0;\n    padding: 0;\n  }\n  \n  .certificate-content {\n    box-shadow: none;\n    border-radius: 0;\n  }\n  \n  body {\n    margin: 0;\n    padding: 0;\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .certificate-container {\n    padding: 10px;\n  }\n  \n  .certificate-actions {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .btn {\n    width: 200px;\n    margin-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
